<!-- @format -->

<div
  class="static-container"
  [ngStyle]="{ 'background-color': backgroundColor }">
  <div class="static-wrapper">
    <!-- No Content Display -->
    @if (showNoContent) {
      <div
        #templateOutlet>
        <home-no-content [chain]="chain"></home-no-content>
      </div>
    }

    <!-- Standard Content Display -->
    @if (!showNoContent) {
      @if (shouldPageHeaderBeRemoved) {
        <div>
          <base target="_parent" />
        </div>
      }
      @if (!shouldPageHeaderBeRemoved) {
        <home-page-header
        [pageTitle]="pageTitle"></home-page-header>
      }
      <div
        #templateOutlet
        class="static-content"
      [isStaticPage]="true"></div>
    }
  </div>
</div>
